<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn color="primary" link to="/marketplace/banners/cadastro">
        <v-icon left>mdi-plus</v-icon>
        Banner
      </v-btn>
      <v-spacer/>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por descrição" v-model="searchText"
                      style="max-width: 400px"
        :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter(this.buildFilter());
    },
    onSelectItem() {
      this.onChangeFilter(this.buildFilter());
    },
    buildFilter() {
      let filter = '';
      if (this.searchText) {
        const value = this.searchText.toLowerCase();
        filter += `descricao like '%${value}%'`;
      }
      return filter;
    },
  },
  data() {
    return {
      searchText: null,
    };
  },
  created() {
    this.onChangeFilter(this.buildFilter());
  },
};
</script>
